export default {
    widget: function(widget, bindingName, binding) {
        if (!kendo.data.binders.widget[widget]) {
            kendo.data.binders.widget[widget] = {};
        }
        kendo.data.binders.widget[widget][bindingName] = binding;
        return binding;
    }
}
